﻿import { Component, OnInit } from '@angular/core';


@Component({ templateUrl: 'pendiente.component.html' })
export class PublicPendienteComponent implements OnInit {


    constructor() {
    }


    ngOnInit() {
    }

   

}
